import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { first, Observable } from 'rxjs';

@Directive({
  selector: '[appLazyLoadImg]',
})
export class LazyLoadImgDirective implements OnInit {
  @Input() appLazyLoadImg!: Observable<string>; // Observable input

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const imgElement: HTMLImageElement = this.el.nativeElement;
    const parent = imgElement.parentElement;

    const skeleton = this.renderer.createElement('div');
    this.renderer.addClass(skeleton, 'info-img-skeleton-loader');
    this.renderer.insertBefore(parent, skeleton, imgElement);

    this.renderer.setStyle(imgElement, 'opacity', '0');
    this.renderer.setStyle(imgElement, 'transition', 'opacity 0.5s');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.appLazyLoadImg.pipe(first()).subscribe((imgSrc) => {
            this.renderer.setProperty(imgElement, 'src', imgSrc);

            imgElement.onload = () => {
              this.renderer.setStyle(imgElement, 'opacity', '1');
              this.renderer.setStyle(skeleton, 'opacity', '0');
              this.renderer.removeChild(parent, skeleton);
            };

            observer.unobserve(imgElement);
          });
        }
      },
      { rootMargin: '100px' }
    );

    observer.observe(imgElement);
  }
}
